
import { Options, Vue } from "vue-class-component";

@Options({
  name: "TheHeaderMetaInfo",
})
export default class MetaInfo extends Vue {}
